<template>
	<div>
		<template v-for="(item, index) in paper.questionsList">
			<div
				:name="`name${item.qid}`"
				v-if="item.questionsTypeId == 501"
				class="box-all"
				:class="{ 'box-all-active': item.isedit && !isBankViewTest }"
				:key="item.oid"
				:id="index"
			>
				<noticeBeforeExam :paper="paper" :question="item" @cutEdit="cutEdit" @delQuestion="delQuestion"></noticeBeforeExam>
			</div>
		</template>

		<draggable 
			v-model="paper.questionsList" 
			animation="300" 
			v-bind="draggableOptions" 
			:move="checkMove" 
			@sort="changeSort"
		>
			<template v-for="(item, index) in paper.questionsList">
				<div
					:name="`name${item.qid}`"
					v-if="item.questionsTypeId != 501"
					class="box-all"
					:class="{ 'box-all-active': item.isedit && !isBankViewTest }"
					:style="{ 'padding': item.questionsTypeId == 402 || item.questionsTypeId == 404 ? '4px 15px' : '15px'}"
					:key="item.oid"
					:id="index"
				>
					<!-- 个人信息 -->
					<div class="content-box" v-if="item.questionsTypeId == 600" @click="cutEdit(index)">
						<div class="box content">
							<div class="box-f" @click="setActiveInput(item.qid)">
								<TitleEditor
									class="outline-none"
									:qid="item.qid"
									:class="item.qid"
									:value="item.questionsName"
                					:actionTitleEditorShow="activeInputId === item.qid"
									@childValueChange="
										val => {
											item.questionsName = val;
										}
									"
								></TitleEditor>
							</div>
							<div class="box-icon" v-if="!isTestEdit && !istestPreview">
								<i v-if="item.isedit" class="el-icon-rank handle"></i>
								<i v-if="item.isedit" class="el-icon-document-add" @click="copyQuestion(item, index)"></i>
								<i class="el-icon-delete" @click="delQuestion(item.qid)"></i>
							</div>
						</div>
						<div class="box-c">
							<el-row>
								<el-col
									:xs="16"
									:sm="16"
									:md="16"
									:lg="16"
									:xl="16"
									class="el_item_option item_container_title"
								>
									<div class="imitation-form-input-text imitation-form-small" 
									:style="{height: item.inputHeight == '小' ? '32px' : (item.inputHeight == '中' ? '51px' : '70px')}">
									</div>
								</el-col>
							</el-row>
						</div>
						<div v-if="item.isedit && !istestPreview" class="edid-box">
							<h4 class="title-h4" v-html="item.questionsName">设置</h4>
							<div class="subject-box">
								<div class="subject">
									<span>此题必答</span>
									<div><el-checkbox v-model="item.mustanswer"></el-checkbox></div>
								</div>
								
								<div class="subject">
									<span>格式切换</span>
									<el-select size="mini" v-model="item.format" filterable placeholder="不限" @change="formatChange(item)" :popper-append-to-body="false">
										<el-option v-for="el in formatList" :key="el.value" :label="el.label" :value="el.value"></el-option>
									</el-select>
								</div>
								<div v-if="item.format == '1'" class="subject">
									<span class="left">位数限制 保留小数点位数</span>
									<div class="right" style="font-size: 14px">
										<el-select v-model="item.decimalPlaces" placeholder="请选择" size="mini">
											<el-option v-for="item in 6" :key="item - 1" :label="item - 1" :value="item - 1"></el-option>
										</el-select>
									</div>
								</div>
								<div v-if="item.format != 5 && item.format != 6 && item.format != 7" class="subject">
									<span v-if="item.format == '1'">最大值</span>
									<span v-else>字数限制</span>
									<div class="subject-but">
										<PopoverNum
                        					controls-position="right"
											:value="item.minNum"
											:size="'mini'"
											:min="item.minNum"
											:max="item.maxNum"
											:type="'min<max'"
											:maxlength="4"
											:content="item.format == '1' ? '最小值不得大于等于最大值' : '最少字数不得大于等于最大字数'"
											:valueType="item.format == '1' ? 'numValue' : 'lengthValue'"
											@valueChange="val => (item.minNum = val)"
										></PopoverNum>
										至
										<PopoverNum
                        					controls-position="right"
											:value="item.maxNum"
											:size="'mini'"
											:min="item.minNum"
											:max="item.maxNum"
											:type="'min>max'"
											:maxlength="4"
											:content="item.format == '1' ? '最大值不得小于等于最小值' : '最多字数不得小于等于最少字数'"
											:valueType="item.format == '1' ? 'numValue' : 'lengthValue'"
											@valueChange="val => (item.maxNum = val)"
										></PopoverNum>
									</div>
								</div>

								<div  v-if="item.format != 4 && item.format != 5 && item.format != 6 && item.format != 7" class="subject">
									<span>默认文本</span>
									<el-input size="mini"
										class="placeholder-input"
										v-model="item.placeholder"
										placeholder="请输入内容"
										@input="val => (item.placeholder = $functions.cutStr(val, 255))"
									></el-input>
								</div>
								<div class="subject">
									<span>输入框高度</span>
									<el-select size="mini" v-model="item.inputHeight" :popper-append-to-body="false">
										<el-option v-for="(item, index) in inputHeightList" :key="index" :label="item" :value="item"></el-option>
									</el-select>
								</div>
							</div>
						</div>
					</div>

					<!-- 单选 多选 判断 -->
					<questionSingle
						:ref="`ques${item.qid}`"
						v-else-if="item.questionsTypeId == 100 || item.questionsTypeId == 101 || item.questionsTypeId == 102"
						:isBankViewTest="isBankViewTest"
						@cutEdit="cutEdit"
						:qindex="index"
						:paper="paper"
						:questionList="paper.questionsList"
						:question="item"
						:isTestEdit="isTestEdit"
						:istestPreview="istestPreview"
						:bankList="bankList"
						@updataQuestion="(val) => questionChange(item, val)"
						@getBankList="getBankList"
						@addToBank="addToBank"
						@addBank="addBank"
						@delFormBank="delFormBank"
						@addOption="addOption"
						@addOptionOther="addOptionOther"
						@delOptionOne="delOptionOne"
						@delQuestion="delQuestion"
						@copyQuestion="copyQuestion"
						:key="item.qid"
						:isBank="isBank"
					></questionSingle>

					<!-- 填空题 简答题 多项填空 横向填空-->
					<questionGap
						:ref="`ques${item.qid}`"
						v-else-if="item.questionsTypeId == 204 || item.questionsTypeId == 206 || item.questionsTypeId == 207 || item.questionsTypeId == 208"
						:isBankViewTest="isBankViewTest"
						:qindex="index"
						:question="item"
						:isTestEdit="isTestEdit"
						:istestPreview="istestPreview"
						:bankList="bankList"
						:isBank="isBank"
						@updataQuestion="(val) => questionChange(item, val)"
						@getBankList="getBankList"
						@cutEdit="cutEdit"
						@addToBank="addToBank"
						@addBank="addBank"
						@delFormBank="delFormBank"
						@addOption="addOption"
						@delOptionOne="delOptionOne"
						@delQuestion="delQuestion"
						@copyQuestion="copyQuestion"
					></questionGap>

					<!-- 更多题型 -->
					<questionMore
						:ref="`ques${item.qid}`"
						v-else-if="item.questionsTypeId == 209 || item.questionsTypeId == 210"
						:isBankViewTest="isBankViewTest"
						:isTestEdit="isTestEdit"
						:istestPreview="istestPreview"
						:qindex="index"
						:question="item"
						:bankList="bankList"
						:isBank="isBank"
						@updataQuestion="(val) => questionChange(item, val)"
						@getBankList="getBankList"
						@cutEdit="cutEdit"
						@addToBank="addToBank"
						@addBank="addBank"
						@delFormBank="delFormBank"
						@delQuestion="delQuestion"
						@copyQuestion="copyQuestion"
					></questionMore>

					<!-- 分页 -->
					<!-- 段落 -->
					<!-- 考前须知 -->
					<questionOtherType
						v-if="item.questionsTypeId == 402 || item.questionsTypeId == 404 || item.questionsTypeId == 401"
						:paper="paper"
						:question="item"
						:istestPreview="istestPreview"
						:qindex="index"
						:isTestEdit="isTestEdit"
						@cutEdit="cutEdit"
						@delQuestion="delQuestion"
						@copyQuestion="copyQuestion"
					></questionOtherType>
				</div>
			</template>
		</draggable>
		<EndPageSetting v-if="!isBank && !istestPreview && !isBankViewTest" :type="'ks'" :paper="paper"></EndPageSetting>
		<div v-if="!istestPreview && !isBankViewTest" class="finish-edit">
			<el-button class="submit-exam" type="danger" @click="submit(1)">完成编辑</el-button>
		</div>
	</div>
</template>
<script>
import draggable from 'vuedraggable';
import TitleEditor from '@/components/titleEditor/titleEditor.vue';
import { v1 as UUID } from 'uuid';
import questionGap from './questionGap.vue';
import questionMore from './questionMore.vue';
import questionSingle from './questionSingle.vue';
import questionOtherType from './questionOtherType.vue';
import noticeBeforeExam from './noticeBeforeExam.vue';
import { mapActions, mapState } from 'vuex';
import Paper from '@/components/examQuesTemplate/js/Paper.js';
import PopoverNum from '@/components/myComponents/popoverNum.vue';
import EndPageSetting from '@/components/endPageSetting/endPageSetting.vue';
import CheckType from '@/util/JSON/checkType.json';
import Option from "@/components/examQuesTemplate/js/Option.js"
import Option2 from "@/components/examQuesTemplate/js/Option2.js"
export default {
	name: 'ExamQuesTemplate',
	components: {
		draggable,
		TitleEditor,
		questionSingle,
		questionGap,
		questionMore,
		PopoverNum,
		questionOtherType,
		noticeBeforeExam,
		EndPageSetting
	},
	props: {
		paper: {
			type: Object,
			default: () => {}
		},
		// 单独的试题编辑（只能编辑当前试题 不能复制以及 移动）
		isTestEdit: {
			type: Boolean,
			default: false
		},
		// 单独试题预览 不能对试题进行操作
		istestPreview: {
			type: Boolean,
			default: false
		},
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
		// 题库编辑试题，不能显示是否收藏按钮
		isBank: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			draggableOptions: {
				handle: '.handle'
			},
			inputHeightList: ['小', '中', '大'],
			bankList: []
		};
	},
	computed: {
		...mapState(['examQuestionTypeArr', 'activeInputId']),
		//选项验证类型
		formatList () {
			return CheckType
		}
	},
	created() {
		this.getBankList();
	},
	methods: {
        ...mapActions(['setActiveInput']),
		questionChange(item, value) {
			this.$set(item, 'scoringType', value.scoringType)
			this.$set(item, 'score', value.score)
			this.$set(item, 'answer', value.answer)
			this.$set(item, 'partialScore', value.partialScore)
			this.$set(item, 'analysis', value.analysis)
			this.$set(item, 'matchingType', value.matchingType)
			this.$set(item, 'optionList', value.optionList)
			this.$set(item, 'scoreArr', value.scoreArr ? [...value.scoreArr] : item.scoreArr)
		},
		formatChange(data) {
			console.log('data :>> ', data);
			if (data.format == 5 || data.format == 6 || data.format == 7) {
				data.decimalPlaces = 0
				data.minNum = 0
				data.maxNum = 0
			}
			if (data.format == 4 || data.format == 5 || data.format == 6 || data.format == 7){
				data.placeholder = ''
			}
		},
		addBank(e, qid) {
			let that = this;
			let data = { ...e, bankType: 0 };
			let params = {
				that: this,
				url: `${this.$config.service.examBankSave}`,
				method: 'POST',
				data: data,
				cb(res) {
					// console.log(res)
					if (res.code == '0') {
						let paper = new Paper();
						that.setPaperJson(res.message, paper, qid);
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},

		setPaperJson(id, paper, qid) {
			let that = this;
			let data = {
				id: id,
				paperjson: JSON.stringify(paper),
				bankType: 0
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankAddQuess}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						that.getBankList();
						// console.log(that.$refs.quesTemplate1)
						let ref = `ques${qid}`;
						// console.log(that.$refs[ref][0])
						that.$refs[ref][0].cancelAddBank();
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		delFormBank(e) {
			let ids = [e.bqid];
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.examBankRecycleBinCancel}?ids=${ids}`,
				method: 'GET',
				cb(res) {
					if (res.code == '0') {
						that.$message({
							message: '取消收藏',
							type: 'success'
						});
						e.bqid = '';
						that.$emit('toGetQuestion');
						that.submit()
					} else {
						that.$message.error('取消失败');
					}
				}
			};
			this.$util.request(params);
		},
		addToBank(e, id) {
			// this.$set(e, 'qid',UUID())
			console.log( e.quesLabelName)
			this.$set(e, 'bid', id);
			let tageName = ''
			if(e.quesLabelName){
				tageName = e.quesLabelName.toString()
			}else{
				tageName = ''
			}
			let that = this;
			let data = {
				quesName: e.questionsName,
				bid: id,
				quesJson: JSON.stringify(e),
				tageName:tageName
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankUpdateQues}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						that.$set(e, 'bqid', res.message);
						that.$message({
							message: '收藏成功',
							type: 'success'
						});
						that.submit()
					} else {
						e.bqid = '';
						e.bid = '';
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		getBankList() {
			let that = this;
			let data = this.$qs.stringify({
				isSystem: 0, // 0自建题库 1系统题库
				pageIndex: 1,
				pageSize: 10000,
				bankType: 0
			});
			let params = {
				that: this,
				url: `${this.$config.service.examBankList}?${data}`,
				method: 'GET',
				cb(res) {
					// console.log(res)
					if (res.code == '0') {
						that.bankList = res.resultBody.datas;
					} else {
						that.bankList = [];
					}
				}
			};
			this.$util.request(params);
		},
		checkMove(evt) {
			const dragged = evt.draggedContext.element;
			const related = evt.relatedContext.element;
			
			// 规则1：禁止拖拽到首页页码（402或404）前
			if ((related.questionsTypeId === 402 || related.questionsTypeId === 404) && 
				related.pageIndex === 0) {
				return false;
			}
			
			// 规则2：相同类型的可以互相拖拽（都是600或都不是600）
			const bothAre600 = dragged.questionsTypeId === 600 && related.questionsTypeId === 600;
			const bothNot600 = dragged.questionsTypeId !== 600 && related.questionsTypeId !== 600;
			
			return bothAre600 || bothNot600;
		},
		changeSort() {
			let pageIndex = 0;
			let quesIndex = 0;
			this.paper.questionsList.forEach((info, index) => {
				if (info.questionsTypeId == 402 || info.questionsTypeId == 404) {
					info.pageIndex = pageIndex++;
				} else if (this.examQuestionTypeArr.indexOf(info.questionsTypeId) != -1) {
					info.quesIndex = quesIndex++;
				}
			});
		},
		// 点击切换编辑状态
		cutEdit(index) {
			this.paper.cancleEdit();
			console.log('this.paper.questionsList :>> ', this.paper.questionsList);
			if (index != undefined && this.paper.questionsList.length > 0) {
				this.paper.questionsList[index].isedit = true;
			}
		},

		// 复制当前题目
		copyQuestion(ques, index) {
			//新插入的问题设置为编辑状态
			this.paper.copyQuestion(ques, index);
		},
		// 删除一个问题
		delQuestion(qid, questionsTypeId) {
			this.paper.delQuestion(qid);
			if (questionsTypeId && (questionsTypeId == 402 || questionsTypeId == 404) && this.paper.pageCount == 2) {
				this.paper.delQuestion(this.paper.questionsList[0].qid);
			}
		},
		// 点击添加选项
		addOption(qid, Arr, qType) {
			console.log('qid, Arr, qType :>> ', qid, Arr, qType);
			// console.log(qid);
			// console.log(Arr)
			if (Arr && Arr.length > 0) {
				// 批量添加
				this.paper.questionsList.forEach(item => {
					if (qid === item.qid) {
						item.optionList.forEach((info) => {
							info.isDefault = false
						})
						Arr.forEach(info => {
							if (qType != 207) {
								let option = new Option(info)
								console.log('option :>> ', option);
								option.isDefault = false
								item.optionList.push(option);
							} else {
								let option = new Option2(info)
								option.isDefault = false
								console.log('option :>> ', option);
								item.optionList.push(option);
							}
						});
					}
				});
			} else {
				this.paper.questionsList.forEach(item => {
					if (qid === item.qid) {
						item.optionList.forEach((info) => {
							info.isDefault = false
						})
						if (qType != 207) {
                            let option = new Option('新增选项')
							option.isDefault = false
							item.optionList.push(option);
						} else {
							let option = new Option2('新增填空')
							option.isDefault = false
							item.optionList.push(option);
						}
					}
				});
			}
		},
		// 添加其他选项
		addOptionOther(qid, Arr) {
			this.paper.questionsList.forEach(item => {
				if (qid === item.qid) {
					item.optionList.forEach((info) => {
						info.isDefault = false
					})
					Arr.forEach(info => {
						let option = new Option(info)
						option.isDefault = false
						option.haveInput = true
						item.optionList.push(option)
					});
				}
			});
		},
		// 删除一个选项
		delOptionOne(qoid) {
			// console.log("删除",qoid);
			for (var j = 0; j < this.paper.questionsList.length; j++) {
				if (qoid.qid == this.paper.questionsList[j].qid) {
					var optionList = this.paper.questionsList[j].optionList;
					for (var i = 0; i < optionList.length; i++) {
						if (qoid.oid == optionList[i].oid) {
							optionList.splice(i, 1);
							break;
						}
					}
				}
			}
		},
		submit(state) {
			this.$emit('submit', state);
		}
	}
};
</script>

<style scoped lang="scss">
/deep/.el-textarea.is-disabled .el-textarea__inner {
	border: 1px solid #dcdfe6;
	background-color: #fff;
	width: 400px;
}
.box-all-active {
	border: 1px solid #409eff !important;
}

.box-all {
	line-height: 30px;
	margin-bottom: 5px;
	background-color: #fff;
	// padding: 15px;
	box-sizing: border-box;
	border-radius: 4px;
	outline: none;
	border: 1px solid #eaeaea;
}
.content-box {
	background-color: rgb(255, 255, 255);
}
.content {
	padding: 0 10px;
}
.box {
	display: flex;
	justify-content: space-between;
}
.box-f {
	width: 80%;
  	font-size: 14px;
	display: flex;
}
.box-f span {
	padding-right: 15px;
}
.box-icon i {
	padding-left: 20px;
}
.box-c,
.box-d {
	padding-left: 22px;
}
.el-container {
	font-size: 14px;
}
.title {
	margin: 10px 0;
}

.tip {
	color: #999;
	font-size: 14px;
	padding-left: 10px;
}
.el-main {
	background-color: #eee;
}
.finish-edit{    
    text-align: center;
    position: fixed;
    bottom: 0px;
    right: 47px;
    z-index: 99;
    width: calc(100% - 450px);
    padding-bottom: 20px;
    background-color: #fff;
	.submit-exam {
		width: 100%;
		margin-top: 20px;
	}
}
.edid-box {
	margin-top: 10px;
	border-top: 1px solid #999;
	font-size: 14px;
	/* height: 400px; */
	padding-bottom: 20px;
}
.title-h4 {
	padding-left: 30px;
}

.subject-box {
	width: 380px;
	line-height: 60px;
	margin: 0 auto;
}
.subject {
	display: flex;
	justify-content: space-between;
	border-bottom: 1px solid #999;
	align-items: center;
}
.placeholder-input {
	width: 64%;
}
.exam-title {
	display: inline-block;
}
.exam-title,
.outline-none {
	outline: none;
    width: 100%;
    margin-bottom: 20px;
}
</style>
<style lang="scss">
.my-bank-tag {
	display: inline-block;
	box-sizing: border-box;
	padding: 1px 6px;
	background: rgba(38, 114, 255, 0.08);
	color: rgba(38, 114, 255, 0.7);
	font-size: 12px;
	line-height: 1.5;
}
</style>
